import { useSession } from '@orthly/session-client';

export const useManufacturerIdFromSession = (): string | undefined => {
    const maybeSession = useSession();
    return maybeSession?.organization_type === 'lab' ? maybeSession.organization_id : undefined;
};
